<template>
  <div class="home">
    <div class="left">
      <!-- 园区概括 -->
      <div class="overview">
        <div class="title">
          <span>园区概括/<i>OVERVIEW</i></span>
        </div>
        <ul>
          <li>
            <span>1487<i>人</i></span>
            <span>员工人数</span>
          </li>
          <li>
            <span>597<i>个</i></span>
            <span>监控数量</span>
          </li>
          <li>
            <span>896<i>个</i></span>
            <span>门禁数量</span>
          </li>
          <li>
            <span>159<i>人</i></span>
            <span>机柜数量</span>
          </li>
        </ul>
      </div>

      <div class="weather">
        <div class="title">
          <span>天气分析/<i>WEATHER ANALYSIS</i></span>
        </div>

        <div class="analysis">
          <div class="wether-font">
            <span>实时天气分析:</span>
            <span>2022/1/19 周二</span>
          </div>
          <div class="analysis-box">
            <div class="wen">
              <span>16°</span>
            </div>
            <ul>
              <li>75良</li>
              <li>晴</li>
              <li>东北风</li>
              <li>1级</li>
              <li>湿度48.0%</li>
              <li>紫外线中等</li>
              <li>日出07:50</li>
              <li>日落18:50</li>
            </ul>
          </div>
        </div>
        <div class="prediction-line">
          <prediction></prediction>
        </div>

        <div class="weather-forecast">
          <span class="weather-title">15天天气预报</span>
          <div class="weather-line">
            <weatherLine></weatherLine>
          </div>
          <ul>
            <li v-for="(item, index) in weatherList" :key="index">
              <span>{{ item.date }}</span>
              <span>(今日)</span>
              <span class=""></span>
              <span>{{ item.maxWen }}</span>
              <span></span>
              <span>{{ item.minWen }}</span>
              <span></span>
              <span>{{ item.wind }}</span>
              <span>{{ item.air }}</span>
            </li>
          </ul>
        </div>
      </div>

      <!-- 监控画面 -->
      <div class="monitor">
        <div class="title">
          <span>监控画面/<i>SURVEILLANCE FOOTAGE</i></span>
        </div>
        <ul>
          <li>
            <span>监控1</span>
            <div class="bg"></div>
          </li>
          <!-- <li>
            <span>监控2</span>
            <div class="bg"></div>
          </li> -->
        </ul>
      </div>
    </div>
    <div class="right">
      <div class="control-door">
        <div class="title">
          <span>门禁通行/<i>ACCESS DATA</i></span>
        </div>
        <div class="door-roll">
          <doorRoll></doorRoll>
        </div>
      </div>

      <!-- 在线设备 -->
      <div class="equipment">
        <div class="title">
          <span>在线设备统计/<i>EQUIPMENT STATISTICS</i></span>
        </div>
        <div class="equipment-pie">
          <equipmentPie></equipmentPie>
        </div>
      </div>

      <!-- 近期工单趋势 -->
      <div class="order">
        <div class="title">
          <span>近期工单趋势/<i>WORK ORDER</i></span>
        </div>
        <div class="order-list-span">
          <span>本日工单: <i class="yellow">8</i></span>
          <span>未处理: <i class="green">8</i></span>
        </div>
        <div class="order-list">
          <orderColumn></orderColumn>
        </div>
      </div>

      <!-- 设备告警 -->
      <div class="warning">
        <div class="title">
          <span>设备告警/<i>EQUIPMENT ALARM</i></span>
        </div>
        <div class="waning-data">
          <ul>
            <li>
              <div class="battery"></div>
              <span class="ttt">蓄电池</span>
              <span class="kkk">5</span>
            </li>
            <li>
              <div class="usp"></div>
              <span class="ttt">USP</span>
              <span class="kkk">5</span>
            </li>
            <li>
              <div class="jigui"></div>
              <span class="ttt">机柜空调</span>
              <span class="kkk">5</span>
            </li>
            <li>
              <div class="camera"></div>
              <span class="ttt">摄像头</span>
              <span class="kkk">5</span>
            </li>
          </ul>
        </div>

        <div class="waing-list">
          <warningList></warningList>
        </div>
      </div>
    </div>
    <div class="bottomBg">
      <div class="bottom-box">
        <div :class="active1 ? 'active' : ''" @click="roam()">场景漫游</div>
        <div :class="active2 ? 'active' : ''" @click="Parade()">楼层巡游</div>
      </div>
      <div class="floor-parade" v-if="floorShow">
        <span
          v-for="(item, index) in floor"
          :key="index"
          :class="{ floorActive: index == floorChange }"
          @click="floorBtn(index)"
          >{{ item }}</span
        >
      </div>

      <div class="play-box" v-if="playBoxShow">
        <div
          class="play"
          :class="playActive ? 'playActive' : ''"
          @click="play()"
        ></div>
        <div class="stop" @click="stop()"></div>
      </div>
    </div>
  </div>
</template>

<script>
import prediction from "../components/prediction.vue";
import equipmentPie from "../components/equipmentPie.vue";
import orderColumn from "../components/orderColumn.vue";
import weatherLine from "../components/weatherLine.vue";
import doorRoll from "../components/doorRoll.vue";
import warningList from "../components/warningList.vue";
export default {
  name: "home",
  data() {
    return {
      weatherList: [
        {
          date: "01/25",
          maxWen: "17℃",
          minWen: "6℃",
          wind: "3-4级<3级",
          air: "良",
        },
        {
          date: "01/25",
          maxWen: "17℃",
          minWen: "6℃",
          wind: "3-4级<3级",
          air: "良",
        },
        {
          date: "01/25",
          maxWen: "17℃",
          minWen: "6℃",
          wind: "3-4级<3级",
          air: "良",
        },
        {
          date: "01/25",
          maxWen: "17℃",
          minWen: "6℃",
          wind: "3-4级<3级",
          air: "良",
        },
      ],
      active: false,
      floorShow: false,
      active1: false,
      active2: false,
      floorChange: 5,
      playBoxShow: false,
      playActive: false,
      floor: ["四楼", "三楼", "二楼", "一楼"],
    };
  },
  components: {
    prediction,
    equipmentPie,
    orderColumn,
    weatherLine,
    doorRoll,
    warningList,
  },
  mounted() {},
  methods: {
    roam() {
      this.active1 = !this.active1;
      this.active2 = false;

      document.getElementById("iframe").contentWindow.MMAPI.electCSS3(7);
      if (this.active1 == true) {
        this.leftRightShow = true;
      } else {
        this.leftRightShow = false;
      }
    },
    Parade() {
      this.active2 = !this.active2;
      this.active1 = false;
      this.floorShow = !this.floorShow;

      this.floorChange = 5;
    },
    floorBtn(index) {
      console.log(index);
      this.floorChange = 0;
      this.floorChange = index;
      this.playBoxShow = true;

      if (index == 3) {
        document.getElementById("iframe").contentWindow.MMAPI.electCSS3(3);
      } else if (index == 2) {
        document.getElementById("iframe").contentWindow.MMAPI.electCSS3(4);
      } else if (index == 1) {
        document.getElementById("iframe").contentWindow.MMAPI.electCSS3(5);
      } else if (index == 0) {
        document.getElementById("iframe").contentWindow.MMAPI.electCSS3(6);
      }
      this.playActive = false;
    },
    play() {
      this.playActive = !this.playActive;
      this.floorShow = false; // 播放时楼层弹框隐藏
      this.active2 = false; // 播放时楼层巡游按钮样式复原

      if (this.playActive == false) {
        document.getElementById("iframe").contentWindow.MMAPI.electCSS3(2);
      } else {
        document.getElementById("iframe").contentWindow.MMAPI.electCSS3(1);
        this.leftRightShow = true; // 播放时左右两边面板隐藏
      }
    },
    stop() {
      document.getElementById("iframe").contentWindow.MMAPI.electCSS3(0);
      this.leftRightShow = false; // 播放时左右两边面板隐藏
      this.playActive = false;
      this.floorShow = false;
      this.active2 = false;
      this.playBoxShow = false;
    },
  },
};
</script>

<style scoped>
.home {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  /* background: url("../assets/img/bg.png"); */
}

.left {
  width: 21.6vw;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: url("../assets/img/left.png");
  background-size: auto;
  background-size: 100% 100%;
  z-index: 12;
}

.right {
  width: 21.6vw;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  background: url("../assets/img/right.png");
  background-size: 100% 100%;
  z-index: 12;
}
/* 底部巡游控制 */
.bottomBg {
  width: 100%;
  height: 4.5vh;
  position: absolute;
  bottom: 0.5%;
  left: 1.5%;
  background: url("../assets/img/bottom.png") no-repeat;
  background-size: auto;
  z-index: 12;
}

.bottom-box {
  width: 13.45vw;
  height: 3.7vh;
  position: absolute;
  left: 41.7vw;
  top: -2.3vh;
  display: flex;
  justify-content: space-between;
}

.bottom-box div {
  width: 6.2vw;
  height: 100%;
  background: url("../assets/img/manyou.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  line-height: 4vh;
  text-indent: 2vw;
  font-size: 0.8vw;
  font-family: SOURCEHANSANSCN-REGULAR;
}

.bottom-box .active {
  width: 6.2vw;
  height: 100%;
  color: #ffbe07;
  background: url("../assets/img/manyouActive.png") no-repeat;
  background-size: 100% 100%;
}

.floor-parade {
  width: 6.1vw;
  height: 15vh;
  background: rgba(17, 8, 3, 0.5);
  position: absolute;
  top: -17.3vh;
  left: 49vw;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  cursor: pointer;
}

.floor-parade span {
  width: 100%;
  height: 2.5vh;
  font-size: 12px;
  font-family: SOURCEHANSANSCN-REGULAR;
  line-height: 2.5vh;
  text-indent: 2.5vw;
}

.floor-parade span.floorActive {
  background: url("../assets/img/floor.png");
  color: #ffbe07;
  cursor: pointer;
}

.play-box {
  width: 4.8vw;
  height: 4vh;
  position: absolute;
  left: 55.5vw;
  top: -2.2vh;
  display: flex;
  justify-content: space-between;
}

.play-box .play {
  width: 1.9vw;
  height: 3.5vh;
  background: url("../assets/img/play.png") no-repeat;
  background-size: 100% 100%;
}

.play-box .playActive {
  width: 1.9vw;
  height: 3.5vh;
  background: url("../assets/img/playA.png") no-repeat;
  background-size: 100% 100%;
}

.play-box .stop {
  width: 1.9vw;
  height: 3.5vh;
  background: url("../assets/img/stop.png") no-repeat;
  background-size: 100% 100%;
}

.overview {
  width: 100%;
  height: 20vh;
  margin-top: 90px;
}

.overview .title {
  width: 232px;
  height: 40px;
  display: flex;
  margin-left: 156px;
  justify-content: center;
  align-items: center;
  background: url("../assets/img/title.png");
}
.overview .title span {
  font-size: 16px;
  color: white;
}
.overview .title span i {
  font-size: 10px;
  color: #b3b3b3;
}

.overview ul {
  width: 100%;
  height: 14.5vh;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.overview ul li {
  width: 5.67vw;
  height: 4vh;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 2.1vh;
}
.overview ul li span i {
  color: white;
  font-size: 12px;
}
.overview ul li span:nth-child(1) {
  width: 100%;
  font-size: 16px;
  color: #efae00;
  text-indent: 2.34vw;
  letter-spacing: 2px;
}
.overview ul li span:nth-child(2) {
  width: 100%;
  font-size: 12px;
   text-indent: 2.34vw;
}

.overview ul li:nth-child(1) {
  background: url("../assets/img/people.png") no-repeat;
  margin-left: 6.78vw;
}
.overview ul li:nth-child(2) {
  background: url("../assets/img/video.png") no-repeat;
  margin-left: 2.4vw;
}
.overview ul li:nth-child(3) {
  background: url("../assets/img/door.png") no-repeat;
  margin-left:1.56vw;
}
.overview ul li:nth-child(4) {
  background: url("../assets/img/jigui.png") no-repeat;
  margin-left: 1.15vw;
}

.weather {
  width: 100%;
  height: 47vh;
}
.weather .title {
  width: 260px;
  height: 40px;
  display: flex;
  margin-left: 80px;
  justify-content: center;
  align-items: center;
  background: url("../assets/img/title1.png");
}
.weather .title span {
  font-size: 16px;
  color: white;
}
.weather .title span i {
  font-size: 10px;
  color: #b3b3b3;
}

.weather .analysis {
  width: 16vw;
  height:6.8vh;
  margin-left: 4.53vw;
  margin-top: 1.6vh;
}
.weather .analysis .wether-font {
  width: 100%;
  height: 1.6vh;
  display: flex;
  justify-content: space-between;
}
.weather .analysis .wether-font span {
  font-size: 12px;
}

.analysis-box {
  width: 100%;
  height: 5.5vh;
  display: flex;
  background: #16130f;
}
.analysis-box .wen {
  width:2.5vw;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 26px;
  color: #ffac0e;
  font-weight: 600;
}
.analysis-box ul {
  width: 13.1vw;
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  font-size: 12px;
  color: #aaa8a5;
}
.analysis-box ul li {
  width: 3.2vw;
  height: 1.8vh;
}
.analysis-box ul li:nth-child(1) {
  margin-top: .7vh;
  width: 2vw;
  height: 1.5vh;
  background: #5a9123;
  display: flex;
  justify-content: center;
  border-radius: 0.5vw;
  color: white;
}
.analysis-box ul li:nth-child(2) {
  width: 2vw;
  height: 1.5vh;
  line-height: 1.8vh;
  text-indent: 1vw;
  background: url("../assets/img/sun.png") no-repeat;
   margin-top: .7vh;
}
.analysis-box ul li:nth-child(3) {
  margin-top: .7vh;
}
.analysis-box ul li:nth-child(4) {
 margin-top: .7vh;
}
.prediction-line {
  height: 100px;
  width: 18vw;
  margin-top: 1.5vh;
  margin-left: 3.125vw;
}
.weather-forecast {
  width: 15.625vw;
  height: 18.5vh;
  margin-left: 3.645vw;
  margin-top: .7vh;
  position: relative;
}
.weather-title {
  font-size: 12px;
}
.weather-forecast ul {
  width: 14.6vw;
  height:18vh;
  margin-top: 3px;
  margin-left: 30px;
  display: flex;
  justify-content: space-between;
}

.weather-forecast ul li {
  width: 3vw;
  height: 100%;
  background: url("../assets/img/weather-list.png") no-repeat;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  font-size: 12px;
  justify-content: center;
  text-align: center;
}

.weather-forecast ul li span:nth-child(1) {
  width: 100%;
  transform: scale(0.8);
}
.weather-forecast ul li span:nth-child(2) {
  width: 100%;
  transform: scale(0.8);
}

.weather-forecast ul li span:nth-child(3) {
  width:1.2vw;
  height: 1.9vh;
  background: url("../assets/img/yun.png");
}

.weather-forecast ul li span:nth-child(4) {
  width: 100%;
  transform: scale(0.8);
  color: #ffba00;
}

.weather-forecast ul li span:nth-child(5) {
  width: 100%;
  height: 2.9vh;
}

.weather-line {
  width: 15.625vw;
  height: 3.7vh;
  position: absolute;
  top: 11vh;
  left: 2.86vw;
}

.weather-forecast ul li span:nth-child(6) {
  width: 100%;
  transform: scale(0.8);
  color: #ffba00;
}

.weather-forecast ul li span:nth-child(8) {
  width: 100%;
  text-align: center;
  transform: scale(0.8);
}

.weather-forecast ul li span:nth-child(9) {
  width: 1.61vw;
  height: 1.7vh;
  border-radius: 5px;
  background: #4c8b16;
  transform: scale(0.8);
}

.monitor {
  width: 17.2vw;
  height: 16vh;
  margin-left: 6.14vw;
}

.monitor .title {
  width: 330px;
  height: 40px;
  display: flex;

  justify-content: center;
  align-items: center;
  background: url("../assets/img/title4.png") no-repeat;
}
.monitor .title span {
  font-size: 16px;
  color: white;
  margin-right: 65px;
}
.monitor .title span i {
  font-size: 10px;
  color: #b3b3b3;
}

.monitor ul {
  width: 15vw;
  height: 10vh;
  margin-top: 1.8vh;
  margin-left: 4.68vw;
  display: flex;
  justify-content: space-between;
}
.monitor ul li {
  width: 7.2vw;
  height: 100%;
  font-size: 12px;
  background: #28231c;
  border-radius: 5px;
}
.monitor ul li div {
  width: 100%;
  height: 100%;
  background: url("../assets/img/jiankong.png") no-repeat;
}
/* 门禁 */
.control-door {
  width: 16.145vw;
  height: 18vh;
  margin-right: 4.53vw;
  margin-top:9.2vh;
}

.control-door .title {
  width: 232px;
  height: 40px;
  display: flex;

  justify-content: center;
  align-items: center;
  background: url("../assets/img/title2.png");
}
.control-door .title span {
  font-size: 16px;
  color: white;
}
.control-door .title span i {
  font-size: 10px;
  color: #b3b3b3;
}

.door-roll {
  width: 14.3vw;
  height: 13vh;
  margin-top: 1.2vh;
}

/* 设备 */
.equipment {
  width:15.625vw;
  height: 19vh;
  margin-right:2vw;
}

.equipment .title {
  width: 298px;
  height: 40px;
  display: flex;
  margin-left: 40px;
  justify-content: center;
  align-items: center;
  background: url("../assets/img/title3.png");
}
.equipment .title span {
  font-size: 16px;
  color: white;
}
.equipment .title span i {
  font-size: 10px;
  color: #b3b3b3;
}

.equipment-pie {
  width: 100%;
  height: 15vh;
  margin-left: 2vw;
}

/* 工单 */
.order {
  width: 18.2vw;
  height: 26vh;
  margin-left: .5vw;
  position: relative;
}

.order .title {
  width: 232px;
  height: 40px;
  display: flex;
  margin-left: 56px;
  justify-content: center;
  align-items: center;
  background: url("../assets/img/title2.png");
}
.order .title span {
  font-size: 16px;
  color: white;
}
.order .title span i {
  font-size: 10px;
  color: #b3b3b3;
}

.order-list {
  width: 100%;
  height:22vh;
}

.order-list-span {
  width:7.2vw;
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  position: absolute;
  left: 8.4vw;
  top: 5.5vh;
}

.order-list-span span .yellow {
  color: #ffa83c;
}

.order-list-span span .green {
  color: #55a90d;
}

/* 告警 */
.warning {
  width: 18vw;
  height: 25vh;
}

.warning .title {
  width: 232px;
  height: 40px;
  display: flex;
  margin-left: 40px;
  justify-content: center;
  align-items: center;
  background: url("../assets/img/title2.png");
}
.warning .title span {
  font-size: 16px;
  color: white;
}
.warning .title span i {
  font-size: 10px;
  color: #b3b3b3;
}

.waning-data {
  width: 13.4vw;
  height: 6.8vh;
  margin-left: 40px;
}
.waning-data ul {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
}
.waning-data ul li {
  width:2.8vw;
  height: 6.5vh;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.waning-data ul li .battery {
  width: 100%;
  height: 3.8vh;
  background: url("../assets/img/battery.png") no-repeat;
}
.waning-data ul li .usp {
  width: 100%;
  height: 3.8vh;
  background: url("../assets/img/usp.png") no-repeat;
}

.waning-data ul li .jigui {
  width: 100%;
   height: 3.8vh;
  background: url("../assets/img/air.png") no-repeat;
}
.waning-data ul li .camera {
  width: 100%;
   height: 3.8vh;
  background: url("../assets/img/camera.png") no-repeat;
}
.ttt {
  width: 100%;
  height:1.6vh;
  font-size: 12px;
  background: url("../assets/img/421.png") no-repeat;
  display: flex;
  justify-content: center;
}
.kkk {
  width: 100%;
  height: 3.8vh;
  text-indent: 1.2vw;
  color: #f77721;
}
.waing-list {
  width: 16.6vw;
  height: 13vh;
  margin-left: -.5vw;
}
</style>
